import { Mask } from "maska";

export function pluralPhrase(count: number, word: string, pluralWord: string | null = null){
  return `${count} ${(count == 1) ? word : (pluralWord ?? `${word}s`)}`;
}
export function plural(count: number, word: string, pluralWord: string | null = null){
  return (count == 1) ? word : (pluralWord ?? `${word}s`);
}
export function scaleTemplate(factor, decimalPlaces = 3) {
  return function (strings, ...values) {
    let out = strings[0]
    for(let i = 0; i < values.length; i++){
      out += (factor * values[i]).toFixed(decimalPlaces)
      out += strings[i + 1]
    }
    return out
  }
}
export function formatGbp(amount: number, maximumFractionDigits: number = 2) {
  return Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits }).format(amount);
}
export function formatPercent(percent: number, minimumFractionDigits: number = 0) {
  return Intl.NumberFormat("en-GB", { style: "percent", minimumFractionDigits}).format(percent / 100);
}
export function formatSortCode(code: string) {
  return new Mask({mask: "##-##-##"}).masked(code);
}
export function formatUkBankSummary(accountNumber: string, sortCode: string, separator: string = " · ") {
  return [accountNumber, formatSortCode(sortCode)].join(separator);
}
